import { useSelector, useDispatch } from "react-redux";
import { authenticationActions } from "../store/authentication";

import useApi from "./useApi";

const useSecurity = () => {
  const dispatch = useDispatch();

  const token = localStorage.getItem("token");
  const isAuthenticated = useSelector(
    (state) => state.authentication.isAuthenticated,
  );

  const { postData } = useApi();

  const login = async (username, password) => {
    const normalizedUsername =
      typeof username === "string" ? username.trim().toLowerCase() : "";

    const results = await postData({
      entityName: "User",
      action: "login",
      data: {
        username: normalizedUsername,
        password,
        source: "web",
      },
    });

    if (results.isSuccessful) {
      dispatch(
        authenticationActions.login({
          token: results.data.token,
          userId: results.data.userId,
          email: results.data.email,
          role: results.data.role,
          language: results.data.language || "en",
        }),
      );
    } else {
      dispatch(authenticationActions.logout());
    }

    return results;
  };

  const logout = async () => {
    // console.log("useSecurity.logout");
    await postData({
      entityName: "User",
      action: "logout",
      data: {},
    });

    dispatch(authenticationActions.logout());
  };

  const forgotPassword = async (username) => {
    const results = await postData({
      entityName: "User",
      action: "forgotPassword",
      data: {
        username,
      },
    });

    return results;
  };

  const changePassword = async (username, confirmationCode, newPassword) => {
    const results = await postData({
      entityName: "User",
      action: "changePassword",
      data: {
        username,
        confirmationCode,
        newPassword,
      },
    });

    return results;
  };

  return {
    token,
    isAuthenticated,
    login,
    logout,
    forgotPassword,
    changePassword,
  };
};

export default useSecurity;
